// Always keep at least one finite breakpoint plus the trailing Infinity column
export const MIN_CUSTOM_BREAKPOINT_COLUMNS = 2;
